import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import {convertPipeToBrTag} from "../../utils";

/**
 * PrimaryNavigation
 */
const PrimaryNavigation = ({
                             containerId,
                             containerClass,
                             links,
                           }) => {
  return (
    <Wrapper
      containerId={containerId}
      containerClass={containerClass}
    >
      <section className="PrimaryNavigation">
        <h3 className="PrimaryNavigation__heading">Primary navigation</h3>
        {(() => {
          if (links !== null) {
            return (
              <ul className="PrimaryNavigation__list-ul">
                {links.map((link, index) => {
                  return (
                    <li key={index}>
                      <Link pageName={link.pageName}
                            pcText={link.pcText}
                            mbText={link.mbText}
                            href={link.href}
                            external={link.external}
                      />
                    </li>
                  )
                })}
              </ul>
            )
          }
        })()}
      </section>
    </Wrapper>
  )
};
PrimaryNavigation.propTypes = {
  containerId: PropTypes.string,
  containerClass: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.shape({
    pageName: PropTypes.string,
    pcText: PropTypes.string,
    mbText: PropTypes.string,
    href: PropTypes.string,
    external: PropTypes.bool,
  })),
};
PrimaryNavigation.defaultProps = {
  containerId: null,
  containerClass: null,
  links: null,
};
export default PrimaryNavigation;

const Link = ({
                pageName,
                pcText,
                mbText,
                href,
                external,
              }) => {
  //
  const getPcText = () => {
    if (pcText && pcText !== '') {
      return pcText;
    }
    return pageName;
  };
  const getMbText = () => {
    if (mbText && mbText !== '') {
      return mbText;
    } else {
      if (pcText && pcText !== '') {
        return pcText;
      }
    }
    return pageName;
  };
  //
  return (
    <a className={'PrimaryNavigation__link' + ((external !== null && external === true) ? ' blank': '')}
       href={href}
       target={(external !== null && external === true) ? '_blank': null}
    >
            <span className="PrimaryNavigation__link-pc">
                <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getPcText())}}/>
            </span>
      <span className="PrimaryNavigation__link-mb">
                <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(getMbText())}}/>
            </span>
    </a>
  )
};



// WEBPACK FOOTER //
// ./src/containers/primary-navigation/index.jsx